import React, {useEffect, useState} from 'react'
import {ModalBase} from '../../../../../components/Modals/ModalBase'
import SearchSelect from '../../../../../components/Inputs/SearchSelect'
import {useDispatch, useSelector} from 'react-redux'
import {State} from '../../../../../reducers'
import InputPhone from '../../../../../components/Inputs/InputPhone'
import {
  facturacionCloseModalCliente,
  facturacionInfoCliente,
} from '../../../../../actions/facturacion/facturacionCliente.actions'
import { getMunicipios } from '../../../../../actions/catalogos.actions'
import { ClienteF } from '../../../../../interfaces/facturacion.interface'

const ModalInfoCliente = (props:any) => {
  const {tipoDocumento, departamentos, municipios, actividadesEconomicas} = useSelector((state: State) => state.catalogos)
  const [catalogoActividadEconomica, ] = useState(actividadesEconomicas.map((tipo) => ({...tipo,codigo_nombre: `${tipo.codigo} - ${tipo.valor}`})))
  const infoCliente = useSelector((state: State) => state.facturacion.modals.infoCliente)
  const dispatch = useDispatch()

  useEffect(() => {
    const depto = departamentos.find((el) => el.codigo === infoCliente?.departamento)?.valor
    if (depto) dispatch(getMunicipios(Number(infoCliente?.departamento), depto, true))
    return () => {
      // close()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const submit = (e: any) => {
    e.preventDefault()
    try {
      const cliente : ClienteF = {
        tipoDocumento: infoCliente?.tipoDocumento,
        nombreTipoDocumento: tipoDocumento?.find((el) => el.codigo === infoCliente?.tipoDocumento)?.valor,
        numId: infoCliente?.numDocumento,
        nombre: infoCliente?.nombre,
        departamento: infoCliente?.departamento,
        nombreDepartamento: infoCliente?.departamento ? departamentos.find((el) => el.codigo === infoCliente?.departamento)?.valor : "",
        municipio: infoCliente?.municipio,
        nombreMunicipio: infoCliente?.municipio ? municipios.find((el) => el.codigo === infoCliente?.municipio)?.valor : "",
        direccion: infoCliente?.direccion,
        email: infoCliente?.email,
        telefono: infoCliente?.telefono,
        actividad: infoCliente?.codActividad,
        nrc: infoCliente?.nrc,
        descripcion: infoCliente?.descActividad,
        correocc: infoCliente?.correocc ?? '',
      }      
      if(props.confirmarDatos) props.confirmarDatos(cliente)
    } catch (error) {}
    close(true)
  }

  const close = (flag: boolean = false) => {
    dispatch(facturacionInfoCliente({}))
    dispatch(facturacionCloseModalCliente())
    if(props?.cancelar && !flag) props.cancelar();
  }

  return (
    <ModalBase Styles={{maxWidth: '700px', width: '70%'}}>
      <div className='card w-form'>
        <form className='form-content' data-wf-page-id='64b58c72be2b65200b1e6fa6' data-wf-element-id='deb0f47f-468f-13fc-f1eb-4d36c39616dc' onSubmit={submit}>
          <div>
            <h3 className='card-title l'>Cliente Encontrado</h3>
          </div>
          <span className='label-input'>
            Se encontró este cliente con la información ingresada. ¿Desea llenar la información?
          </span>
          <div className='w-layout-hflex h-inputs'>
            <div className='label-input'>
              <label htmlFor='tipoDocumento' className='field-label m'>
                Tipo de documento de identificación
              </label>
              <SearchSelect
                disabled={true}
                placeholder='Tipo de Identificación'
                value={infoCliente?.tipoDocumento}
                name='tipoDocumento'
                data={tipoDocumento}
                keyNameText='valor'
                keyNameValue='codigo'
                onChange={(value: any) => {}}
                defaultValue={null}
              />
            </div>
            <div className='label-input'>
              <label htmlFor='numId' className='field-label m'>
                {tipoDocumento?.find((el) => el.codigo === infoCliente?.tipoDocumento)?.valor}
              </label>
              <input
                autoComplete='off'
                type='text'
                className='m text-field w-input'
                name='numId'
                data-name='numId'
                id='numId'
                disabled={true}
                value={infoCliente?.numDocumento}
              />
            </div>
          </div>
          <div className='w-layout-hflex h-inputs'>
            <div className='label-input'>
              <label htmlFor='nombre' className='field-label m'>
                Nombre del cliente
              </label>
              <input
                autoComplete='off'
                type='text'
                className='m text-field w-input'
                name='nombre'
                data-name=''
                placeholder='Nombre del cliente'
                id='nombre'
                disabled={true}
                maxLength={250}
                value={infoCliente?.nombre}
              />
            </div>
            <div className='label-input'>
              <label htmlFor='departamento' className='field-label m'>
                Departamento
              </label>
              <SearchSelect
                defaultValue={null}
                disabled={true}
                placeholder='Actividad económica'
                value={infoCliente?.departamento}
                name='actividad'
                data={departamentos}
                keyNameText='valor'
                keyNameValue='codigo'
                onChange={(value: any) => {}}
              />
            </div>
          </div>
          <div className='w-layout-hflex h-inputs'>
            <div className='label-input'>
              <label htmlFor='municipio' className='field-label m'>
                Municipio
              </label>
              <SearchSelect
                defaultValue={null}
                disabled={true}
                placeholder='Actividad económica'
                value={infoCliente?.municipio}
                name='municipio'
                data={municipios}
                keyNameText='valor'
                keyNameValue='codigo'
                onChange={(value: any) => {}}
              />
            </div>
            <div className='label-input'>
              <label htmlFor='direccion' className='field-label m'>
                Dirección
              </label>
              <input
                autoComplete='off'
                type='text'
                className='m text-field w-input'
                name='direccion'
                data-name=''
                placeholder='Dirección'
                id='direccion'
                disabled={true}
                maxLength={200}
                value={infoCliente?.direccion}
              />
            </div>
          </div>
          <div className='w-layout-hflex h-inputs'>
            <div className='label-input'>
              <label htmlFor='email' className='field-label m'>
                Correo electrónico
              </label>
              <input
                autoComplete='off'
                type='email'
                className='m text-field w-input'
                name='email'
                data-name='Correo electrónico'
                placeholder='Correo electrónico'
                id='email'
                disabled={true}
                value={infoCliente?.email}
              />
            </div>
            <div className='label-input'>
              <label htmlFor='telefono' className='field-label m'>
                Teléfono celular
              </label>
              <InputPhone
                disabled={true}
                value={infoCliente?.telefono}
                onChange={() => {}}
                onBlur={() => {}}
                className='telefono-style'
                name='telefono'
              />
            </div>
          </div>
          <div className='w-layout-hflex h-inputs'>
            {props?.noActividad !== true && <div className='label-input'>
              <label htmlFor='actividad' className='field-label m'>
                Actividad
              </label>
              <SearchSelect
              defaultValue={null}
                disabled={true}
                placeholder='Actividad económica'
                value={infoCliente?.codActividad}
                name='actividad'
                data={catalogoActividadEconomica}
                keyNameText='codigo_nombre'
                keyNameValue='codigo'
                onChange={(value: any) => {}}
              />
            </div>}
            {props?.noNRC !== true && <div className='label-input'>
              <label htmlFor='nrc' className='field-label m'>
                NRC
              </label>
              <input
                autoComplete='off'
                type='text'
                className='m text-field w-input'
                name='nrc'
                data-name=''
                placeholder='NRC'
                id='nrc'
                disabled={true}
                maxLength={250}
                value={infoCliente?.nrc}
              />
            </div>}
          </div>
          <div className='form-separator'></div>
          <div className='w-layout-hflex button-actions'>
            <button type='button' className='m button transparent w-inline-block' onClick={() => close(false)}>
              <div>Cancelar</div>
            </button>
            <button autoFocus type='submit' className='m button w-inline-block'>
              <div>Confirmar</div>
            </button>
          </div>
        </form>
      </div>
    </ModalBase>
  )
}

export default ModalInfoCliente
